import PropTypes from 'prop-types';
import React from 'react';
import { graphql, Link, useStaticQuery } from 'gatsby';
import GatsbyImage from 'gatsby-image';

function JustDropped({ collection }) {
  const { caprisImage, jeansImage } = useStaticQuery(graphql`
    {
      caprisImage: file(relativePath: { eq: "capris-wide.jpg" }) {
        childImageSharp {
          fluid(maxWidth: 1920) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      jeansImage: file(relativePath: { eq: "jeans-wide.jpg" }) {
        childImageSharp {
          fluid(maxWidth: 1920) {
            ...GatsbyImageSharpFluid
          }
        }
      }
    }
  `);

  let image;
  let firstLine;
  let secondLine;
  let buttonLabel;
  switch (collection) {
    case 'jeans':
      image = jeansImage;
      firstLine = 'New season';
      secondLine = 'just dropped';
      buttonLabel = 'Shop now';
      break;

    case 'capris':
      image = caprisImage;
      firstLine = 'Spring’s a thing';
      secondLine = 'so dress for it';
      buttonLabel = 'Shop capris now';
      break;

    default:
      image = jeansImage;
      firstLine = 'New season';
      secondLine = 'just dropped';
      buttonLabel = 'Shop jeans now';
  }

  return (
    <article className="relative">
      <div className="absolute inset-0 sm:h-0 sm:relative sm:aspect-ratio-21/9">
        <div className="absolute inset-0 flex bg-light-pink">
          <GatsbyImage fluid={image.childImageSharp.fluid} className="flex-1" />
        </div>
      </div>
      <div className="relative flex items-center justify-center sm:absolute sm:inset-0">
        <div className="py-24 text-center text-white uppercase">
          <h2 className="text-3xl text-shadow">
            {firstLine} <br />
            <span className="text-5xl font-bold uppercase">{secondLine}</span>
          </h2>
          <Link to={`/collections/${collection}/`} className="mt-2 button">
            {buttonLabel}
          </Link>
        </div>
      </div>
    </article>
  );
}

JustDropped.propTypes = {
  collection: PropTypes.string,
};

export { JustDropped };
